module.exports = "//d274d294w9cx2v.cloudfront.net/055f994f407a30cab1de7f2871266bf6a03a0a8c/images/venmoBadge.png";